export default "__VITE_ASSET__2a090183__"